export default "__VITE_ASSET__CcTPxbwW__"